import { useState, useEffect } from 'react';

const useOrderSummary = ({ sale_order_line = [], orderTax = 0, orderTaxMethod = '%', orderDiscount = 0, orderDiscountMethod = 'rs' }) => {
    const [orderSummary, setOrderSummary] = useState({
        totalAmount: 0,
        subTotalAmount: 0,
        totalDiscountAmount: 0,
        totalTaxAmount: 0,
        totalDiscountPerItem: 0
    });

    const calculateOrderSummary = () => {
        let totalAmount = 0;
        let subTotalAmount = 0;
        let totalDiscountAmount = 0;
        let totalTaxAmount = 0;
        let totalDiscountPerItem = 0;

        sale_order_line.forEach(element => {
            const quantity = element?.quantity || 1;
            const discountAmount = element?.discount_method === 'rs'
                ? element?.discount
                : (element.selling_price * element?.discount) / 100;

            totalAmount += (quantity * (element.selling_price - discountAmount));
            subTotalAmount += (quantity * element.selling_price);
            totalDiscountPerItem += (quantity * discountAmount);
        });


        totalDiscountAmount = orderDiscountMethod === 'rs'
            ? orderDiscount
            : (totalAmount * orderDiscount) / 100;

        totalTaxAmount = orderTaxMethod === '%'
            ? ((subTotalAmount - totalDiscountPerItem - totalDiscountAmount) * orderTax) / 100
            : orderTax;
        totalAmount = (totalAmount - totalDiscountAmount) + totalTaxAmount;

        setOrderSummary({
            totalAmount,
            subTotalAmount,
            totalDiscountAmount,
            totalTaxAmount,
            totalDiscountPerItem
        });
    }
    useEffect(() => {
        calculateOrderSummary()
    }, [sale_order_line, orderTax, orderTaxMethod, orderDiscount, orderDiscountMethod]);

    return { ...orderSummary, calculateOrderSummary };
};

export default useOrderSummary;
